
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.animateStat(this.$refs['esg-stat-1'], this.blok.stat_1_start)
      this.animateStat(this.$refs['esg-stat-2'], this.blok.stat_2_start)
      this.animateStat(this.$refs['esg-stat-3'], this.blok.stat_3_start)
      this.animateStat(this.$refs['esg-stat-4'], this.blok.stat_4_start)
      this.animateStat(this.$refs['esg-stat-1-mobile'], this.blok.stat_1_start)
      this.animateStat(this.$refs['esg-stat-2-mobile'], this.blok.stat_2_start)
      this.animateStat(this.$refs['esg-stat-3-mobile'], this.blok.stat_3_start)
      this.animateStat(this.$refs['esg-stat-4-mobile'], this.blok.stat_4_start)
    },
    animateStat(scope, start) {
      this.$gsap.context(() => {
        const increment = this.increment

        const tl = this.$gsap
          .timeline({
            repeat: 3,
            // yoyo: true,
            repeatRefresh: true,
            // repeatDelay: 0.5,
            onComplete() {
              const statNumber = scope.querySelector('.stat-number')
              statNumber.innerHTML = 0
              tl.progress(0).restart()
            },
          })

          .to('.stat-number', {
            innerHTML() {
              const prev = this._targets?.[0].innerHTML

              return increment(prev, start, scope)
            },
            duration: 3,
            snap: {
              innerHTML: 1,
            },
          })
          .fromTo(
            '.line',
            {
              drawSVG: 0,
            },
            {
              drawSVG: '100%',
              duration: 3,
              // stagger: 0.1,
            },
            '<'
          )
          .fromTo(
            '.bar',
            {
              attr: { height: 0 },
            },
            {
              attr: { height: '83%' },
              duration: 3,
            },
            '<'
          )
      }, scope)
    },
    increment(prev, start, scope) {
      const next = Number(prev) + this.getRand(15, 20)

      if (!prev) {
        return Number(start)
      }

      if (next >= 100) {
        return 99
      }

      return next
    },
    getRand(min, max) {
      return Math.random() * (max - min) + min
    },
  },
}
